"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_core_1 = require("owa-options-core");
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_outlook_service_options_1 = require("owa-outlook-service-options");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () {
        return owa_outlook_service_options_1.getOptionsForFeature(owa_outlook_service_options_1.OwsOptionsFeatureType.SmartSuggestions);
    },
})(function isQuickSuggestionsOptionDirty(state) {
    var optionState = state.optionState, userOptions = state.userOptions;
    var smartSuggestionsEnabled = owa_options_core_1.getFallbackValueIfNull(optionState.smartSuggestionsEnabled, userOptions.smartSuggestionsEnabled);
    var browserLocationEnabled = owa_options_core_1.getFallbackValueIfNull(optionState.browserLocationEnabled, userOptions.browserLocationEnabled);
    return (smartSuggestionsEnabled !== userOptions.smartSuggestionsEnabled ||
        browserLocationEnabled !== userOptions.browserLocationEnabled);
});
//# sourceMappingURL=isQuickSuggestionsOptionDirty.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-quick-suggestions-option/lib/utils/isQuickSuggestionsOptionDirty.js
// module id = 5134
// module chunks = 2